import { render, staticRenderFns } from "./cellDeta.vue?vue&type=template&id=722a45b6&scoped=true"
import script from "./cellDeta.vue?vue&type=script&lang=js"
export * from "./cellDeta.vue?vue&type=script&lang=js"
import style0 from "./cellDeta.vue?vue&type=style&index=0&id=722a45b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a45b6",
  null
  
)

export default component.exports